import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Title from '../../title';
import Webcontrol from './webcontrol';
import History from './history';

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
});

class Addmenu extends React.Component {
  state = {
    value: 0,
    values: 0
  };

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuControl = this.props.menus;
    var x;
    menuControl.map((z) => {
      if (z.menu == 'sms') {
        if (z.edit == 1) {
          this.setState({ viewEdit: 'show' })
        }
        else {
          this.setState({ viewEdit: 'none' })
        }
      }
    })
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  onChange(val) {
    this.setState({
      values: val
    });
  }

  render() {
    const { classes, theme } = this.props;
    let x, y, z, section, category, brand;
    if (this.state.values == 0) {
      x = (<Webcontrol />);
    }
    if (this.state.values == 1) {
      y = (<div><History /></div>);
    }

    return (
      <div className={classes.root}>
        <Title title={'Web Access'} openDrawer={this.props.openDrawer}/>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Executive Control" onClick={this.onChange.bind(this, 0)} />
            <Tab label="Executive History" onClick={this.onChange.bind(this, 1)} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}>
          {x}{y}
        </SwipeableViews>
      </div>
    );
  }
}

Addmenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Addmenu);
